// ** Cotizador v3 translations (react-intl classic system)
// key === English source string, value === translation.
import en from './en.json';
import mx from './mx.json';

export default { en, mx };
